import React from "react";
import Tree from "react-d3-tree";

const orgChart = {
  name: "MLM POINT",
  children: [
    // Left tree
    {
      name: "Sonu Kumar",
      attributes:{
        userID: "mono7857474"
      },
      children: [
        {
          name: "Sumon Khan",
          attributes:{
            userID: "mono7857474"
          },
        },
        {
          name: "Dev",
          attributes:{
            userID: "mono7857474"
          },
        },
      ],
    },
    // Right tree
    {
      name: "Pranay Mojumdar",
      attributes:{
        userID: "mono7857477"
      },
      children: [
        {
          name: "Shikha Ghosh",
          attributes:{
            userID: "mono7857477"
          },
        },
        {
          name: "Mahindra Singh",
          attributes:{
            userID: "mono7857477"
          },
        },
      ],
    },
  ],
};

const MyTreePage = () => {
  return (
    <div className="mono_teamtree_page_wrapper">
      <div className="mono_teamtree_title">
        <h2>My Tree</h2>
      </div>
      <div id="treeWrapper" style={{ height: "30em" }}>
        <Tree
          data={orgChart}
          orientation="vertical"
          centeringTransitionDuration={true}
          enableLegacyTransitions={true}
          collapsible={true}
          translate={{
            x: 450,
            y: 100
          }}
        />
      </div>
    </div>
  );
};

export default MyTreePage;
